/**
 * Slash AI handlers
 *
 * Creates the execute functions for each /ai sub-command.
 * These are injected into the SlashSubcommand objects at runtime.
 */

export interface SlashAiHandlerOptions {
  /** Open AiDialog in create mode with pre-filled prompt */
  onAiCreate: (prompt: string) => void;
  /** Open AiDialog in modify mode with pre-filled prompt */
  onAiModify: (prompt: string) => void;
  /** Open AiExplainDialog */
  onAiExplain: () => void;
  /** Open AiImproveDialog */
  onAiImprove: () => void;
  /** Open AiDialog in fix mode */
  onAiFix: () => void;
}

export function createAiExecutors(opts: SlashAiHandlerOptions) {
  return {
    create: (arg?: string) => opts.onAiCreate(arg ?? ''),
    modify: (arg?: string) => opts.onAiModify(arg ?? ''),
    explain: () => opts.onAiExplain(),
    improve: () => opts.onAiImprove(),
    fix: () => opts.onAiFix(),
  };
}
